<template>
  <div class="comp-skeleton-cooperation">
    <jw-skeleton :animation="animation" class="cooperation-skeleton">
      <jw-skeleton-shape shape="circle" size="small" class="skeleton-item" />
      <jw-skeleton-shape shape="circle" size="small" class="skeleton-item" />
      <!-- <jw-skeleton-shape shape="circle" size="small" /> -->
    </jw-skeleton>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
@import './fh-skeleton-cooperation.less';
</style>
